import Users from '@/api/users'
import DefaultAvatar from '@/assets/avatar-default.png'
import DefaultCover from '@/assets/header-default.png'
import DefaultCoverIcon from '@/assets/cover-picture-icon.png'

export default {
  namespaced: true,
  state: {
    user: null,
    retry: 0,
    profiles: [],
    socialProfiles: [],
    intercomUser: null
  },
  getters: {
    profiles: state => state.profiles,
    socialProfiles: state => state.socialProfiles,
    retry: state => state.retry,
    user: state => {
      return state.user
    },
    fullName: state => {
      if (state.user && state.user.name) {
        return `${state.user.firstName} ${state.user.lastName}`
      } else {
        return ''
      }
    },
    profilePictureUrl: (state, getters) => {
      return getters.imageUrlForUser(state.user)
    },
    imageUrlForUser: state => user => {
      if (user && user.profilePictureUrl) {
        return user.profilePictureUrl
      } else if (user && user.id) {
        return `/api/identicons/${user.id}`
      } else {
        return DefaultAvatar
      }
    },
    coverImageForUser: state => user => {
      if (user) {
        return user.coverPictureUrl || DefaultCover
      } else {
        return DefaultCover
      }
    },
    coverPictureUrl: (state, getters) => {
      return getters.coverImageForUser(state.user)
    },
    coverPictureIconUrl: state => {
      if (state.user) {
        return state.user.coverPictureThumbnailUrl || DefaultCoverIcon
      } else {
        return DefaultCoverIcon
      }
    },
    userid: state => state.user.id
  },
  mutations: {
    setUser (state, user) {
      state.user = user
    },
    setRetry (state, retry) {
      state.retry = retry
    },
    setProfiles (state, profiles) {
      state.profiles = profiles
    },
    setSocialProfiles (state, profiles) {
      state.socialProfiles = profiles
    },
    setIntercomUser (state, user) {
      state.intercomUser = user
    }
  },
  actions: {
    async getCurrentUserInfo ({commit, dispatch, getters}) {
      try {
        const user = await Users.getCurrentUserEmail()
        commit('setIntercomUser', user)
      } catch (err) {
        const retry = getters.retry + 1
        commit('setRetry', retry)
        setTimeout(function () {
          dispatch('getUser')
          dispatch('getCurrentUserInfo')
        }, 2000 * retry)
      }
    },
    async getUser ({commit}) {
      if (!window.location.pathname.includes('/widget')) {
        const user = await Users.current()
        commit('setUser', user)
      }
    },
    async uploadProfileImage ({ commit }, file) {
      const user = await Users.uploadProfileImage(file)
      commit('setUser', user)
    },
    async uploadCoverImage ({ commit }, file) {
      const user = await Users.uploadCoverImage(file)
      commit('setUser', user)
    },
    async updateUser ({ commit }, data) {
      try {
        const user = await Users.updateUser(data)
        commit('setUser', user)
      } catch (error) {
        console.log(error)
        throw error
      }
    },
    async createOrUpdateSocialProfiles ({ commit, state }) {
      const profiles = await Users.createOrUpdateSocialProfiles(state.socialProfiles)
      commit('setProfiles', profiles)
    },
    async getUserProfiles ({ commit }, userId) {
      const profiles = await Users.getSocialProfiles(userId)
      commit('setProfiles', profiles)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js